export const DEFAULT_COLOR = '#D22';
export const PRIMARY_COLOR_ERROR = 'Pick a primary color to derive color palette from';
export const SERVER_ERROR = 'There was a server error. Please try again later or contact support.';
